import React, { useState } from "react";
import { Button, Col, Row, Form } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  Editor,
  EditorProvider,
} from "react-simple-wysiwyg";
import "react-toastify/dist/ReactToastify.css";
import { Helmet } from "react-helmet";

const CreateAnouncement = (props) => {

  const { selectedUsers } = props;

  console.log('filterData--->', selectedUsers);

  const navigate = useNavigate();
  const [anndetails, setAnnDetails] = useState({
    title: "",
    description: "",
    media: [],
  });
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewFiles, setPreviewFiles] = useState([]);
  const [fileDescription, setFileDescription] = useState("");

  const handleFileChange = (e) => {
    let files = Array.from(e.target.files);
    if (previewFiles.length < 5 && files.length > 0) {

      console.log('pawan file--->', files);

      files[0].url = URL.createObjectURL(files[0]);

      setSelectedFiles((previous) => [...previous, ...files]);

      let previews = files;

      setPreviewFiles((previous) => {
        const newFiles = previews.filter(
          (newFile) => !previous.some((file) => file.name === newFile.name)
        );

        return [...previous, ...newFiles];
      });
    }
    else {
      return toast.error('You can only upload 5 files at a time');
    }
  };
  const removeFile = (index) => {
    setSelectedFiles(prev => prev.filter((_, i) => i !== index));
    setPreviewFiles(prev => prev.filter((_, i) => i !== index));
  };

  const handleSave = async (e) => {
    e.preventDefault();

    if (anndetails.title === "") {
      toast.error("Title is required.");
      return;
    }

    try {
      const announcementData = {
        title: anndetails.title,
        description: anndetails.description,
        users: selectedUsers,
      };

      const createdAnouncement = await schoolApi.createAnouncement(announcementData);

      if (createdAnouncement.success === true) {

        for (let i = 0; i < previewFiles.length; i++) {
          console.log('file count--->', previewFiles[i]);
          let formData = new FormData();
          formData.append(`files${i}`, previewFiles[i]);
          formData.append(`description`, fileDescription);

          console.log('formData-on handleSubmit->', formData);

          const fileResult = await schoolApi.createFile(
            createdAnouncement?.record?.id,
            formData
          );

          console.log('fileResult-->', fileResult); 
        }

        const notificationDetails = {
          users: selectedUsers,
          announcementRecord: createdAnouncement?.record
        }

        const resultNotification = await schoolApi.sendPushNotification(notificationDetails);
        console.log('createdAnouncement--->', resultNotification);

        toast.success(createdAnouncement.message);
        return navigate("/announcements");
      } else {
        return toast.error(createdAnouncement.message);
      }
    } catch (error) {
      return toast.error(error.response?.data?.message || "An error occurred");
    }
  };


  console.log('previewFiles--->', previewFiles);

  return (
    <>
      <div className="container-fluid">
        <Row>
          <Col lg={12}>
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Create New Announcement</h4>
              </div>
              <div className="card-body">
                <Form >
                  <Row>
                    <Col md={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                          type="text"
                          name="title"
                          placeholder="Enter Title"
                          value={anndetails.title}
                          onChange={(e) =>
                            setAnnDetails({
                              ...anndetails,
                              title: e.target.value,
                            })
                          }
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* <Row>
                    <Col lg={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Files</Form.Label>
                        <Form.Control
                          type="file"
                          multiple
                          onChange={handleFileChange}
                          className="mb-2"
                        />
                        <div className="d-flex flex-wrap gap-2">
                          {previewFiles?.map((file, index) => (
                            <div key={index} className="file-preview d-flex align-items-center p-2 border rounded">
                              {file.type?.startsWith('image/') ? (
                                <img src={file.url} alt={file.name} style={{ width: '50px', height: '50px', objectFit: 'cover' }} />
                              ) : (
                                <i className="fa-solid fa-file"></i>
                              )}
                              <span className="ms-2">{file.name}</span>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger ms-2"
                                onClick={() => removeFile(index)}
                              >
                                <i className="fa-solid fa-times"></i>
                              </button>
                            </div>
                          ))}
                        </div>
                      
                      </Form.Group>
                    </Col>
                  </Row> */}

                  <Row>
                    <Col lg={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Files</Form.Label>
                        <Form.Control
                          type="file"
                          multiple
                          onChange={handleFileChange}
                          className="mb-2"
                          accept="image/*,video/*,.pdf,.doc,.docx,.xls,.xlsx,.csv,.txt"
                        />
                        <div className="d-flex flex-wrap gap-2">
                          {previewFiles.map((file, index) => (
                            <div key={index} className="file-preview d-flex align-items-center p-2 border rounded">
                              {file.type.startsWith("image/") ? (
                                <img src={file.url} alt={file.name} style={{ width: "50px", height: "50px", objectFit: "cover" }} />
                              ) : file.type.startsWith("video/") ? (
                                <video src={file.url} controls style={{ width: "50px", height: "50px", objectFit: "cover" }} />
                              ) : file.type === "application/pdf" ? (
                                <a href={file.url} target="_blank" rel="noopener noreferrer" className="text-decoration-none">
                                  <i className="fa-solid fa-file-pdf text-danger"></i> {file.name}
                                </a>
                              ) : file.type.includes("word") || file.name.endsWith(".doc") || file.name.endsWith(".docx") ? (
                                <i className="fa-solid fa-file-word text-primary"></i>
                              ) : file.type.includes("spreadsheet") || file.name.endsWith(".xls") || file.name.endsWith(".xlsx") ? (
                                <i className="fa-solid fa-file-excel text-success"></i>
                              ) : file.name.endsWith(".csv") ? (
                                <i className="fa-solid fa-file-csv text-info"></i>
                              ) : file.name.endsWith(".txt") ? (
                                <i className="fa-solid fa-file-lines text-secondary"></i>
                              ) : (
                                <i className="fa-solid fa-file"></i>
                              )}
                              <span className="ms-2">{file.name}</span>
                              <button type="button" className="btn btn-sm btn-danger ms-2" onClick={() => removeFile(index)}>
                                <i className="fa-solid fa-times"></i>
                              </button>
                            </div>
                          ))}
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <EditorProvider className="resizable-editor">
                          <Editor
                            name="description"
                            placeholder="Enter description"
                            onChange={(e) =>
                              setAnnDetails({
                                ...anndetails,
                                description: e.target.value,
                              })
                            }
                            value={anndetails.description}
                          >
                          </Editor>
                        </EditorProvider>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col lg={12}>
                      <div className="d-flex justify-content-end gap-2">
                        <Button variant="light" onClick={() => navigate("/announcements")}>
                          Cancel
                        </Button>
                        <Button type="submit" variant="primary" onClick={handleSave}>
                          Create Announcement
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
      />
    </>
  );
};

export default CreateAnouncement;
